import React from 'react';
import styled, { withTheme } from 'styled-components';
import Ink from 'react-ink';
import PropTypes from 'prop-types';
import theme from 'services/theme.semantic';

const IconText = ({
  children,
  isActive,
  shouldAnimate,
  shouldInk,
  activeColor,
  stretch,
}) => (
  <Wrapper>
    <Icon
      isActive={isActive}
      shouldAnimate={shouldAnimate}
      activeColor={activeColor}
      stretch={stretch}
    >
      {children}
      {shouldInk && <Ink />}
    </Icon>
  </Wrapper>
);

const Wrapper = styled.div`
  padding-top: ${props => props.theme.spacing.xs};
`;

const Button = ({ children, className }) => (
  <button className={className} type="button">
    {children}
  </button>
);

Button.propTypes = {
  style: PropTypes.shape({}),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

Button.defaultProps = {
  className: '',
  style: {}
};

// To prevent styled components from automatic passing down of props
// We instead style the Button that only desctructs the necessary props
// Se issue: https://github.com/styled-components/styled-components/issues/135
/* eslint-disable-next-line no-unused-vars */
const Icon = styled(({ activeColor, ...rest }) => <Button {...rest} />)`
  position: relative;
  height: 40px;
  width: ${props => (props.stretch ? '192px' : '40px')};
  font-size: ${props => props.theme.sizes.xs};
  font-weight: ${props => (props.isActive ? props.theme.weight.base : props.theme.weight.xbase)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: ${props => (props.stretch ? 'left' : 'center')};
  padding: ${props => props.theme.spacing.xs}
    ${props => (props.stretch ? props.theme.spacing.xs : props.theme.spacing.xs4)};
  cursor: pointer;
  background-color: ${({
    theme,
    isActive = false,
    shouldAnimate,
    activeColor,
  }) => (isActive || !shouldAnimate ? activeColor : theme.colors.bgLighterS)};
  color: ${props => (props.isActive ? props.theme.colors.baseInverse : props.theme.colors.base)};
  border: 0;
  transition: background-color 0.2s ease-in-out;
  &:hover {
    background-color: ${({ activeColor }) => activeColor};
  }
  &:focus {
    outline: 0;
  }
`;

Icon.propTypes = {
  isActive: PropTypes.bool,
  shouldAnimate: PropTypes.bool,
  activeColor: PropTypes.string,
  stretch: PropTypes.bool,
};

Icon.defaultProps = {
  isActive: false,
  shouldAnimate: true,
  activeColor: theme.colors.primary,
  stretch: false,
};

IconText.propTypes = {
  isActive: PropTypes.bool,
  shouldAnimate: PropTypes.bool,
  children: PropTypes.node.isRequired,
  shouldInk: PropTypes.bool,
  activeColor: PropTypes.string,
  stretch: PropTypes.bool,
};

IconText.defaultProps = {
  isActive: false,
  shouldAnimate: true,
  shouldInk: true,
  activeColor: theme.colors.primary,
  stretch: false,
};

export default withTheme(IconText);
